<div class="nav-wrapper">
  <div class="nav-left-action">
    <bw-icon-legacy [iconName]="leftIconName" size="24" (click)="handleLeftAction($event)"></bw-icon-legacy>
  </div>
  <div class="nav-right-action">
    <bw-icon-legacy [iconName]="rightIconName" size="24" (click)="handleRightAction($event)"></bw-icon-legacy>
  </div>
</div>
